import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import store, { IAppState } from "../../state/Store";
import Datastore from "../../communication/Datastore";
import SSOProvider from "../../types/core/SSOProvider";
import { REHYDRATE } from "redux-persist";

// Define the type for our state store entry
type SSOState = {
    provider: SSOProvider;
    status: string;
    error: string;
};

// Define the initial state for our state store entry
const initialState: SSOState = {
    provider: null,
    status: "idle",
    error: null,
};

// Create a slice to hold all our reducers
const ssoSlice = createSlice({
    name: "sso",
    initialState: initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(REHYDRATE, (_, rawData: any) => {
                if (rawData?.key !== "tts") return undefined;
                return {
                    provider: rawData?.payload?.sso?.provider ?? null,
                    status: !rawData?.payload?.sso?.provider
                        ? "idle"
                        : rawData?.payload?.sso?.status,
                    error: null,
                };
            })
            .addCase(fetchSSOProviders.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(fetchSSOProviders.fulfilled, (state, action) => {
                state.status = "succeeded";
                // Add any fetched posts to the array
                state.provider = new SSOProvider(action.payload[0]);
            })
            .addCase(fetchSSOProviders.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            .addCase(saveSSO.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(saveSSO.fulfilled, (state, action) => {
                state.status = "succeeded";
                // Add any fetched posts to the array
                state.provider = new SSOProvider(action.payload[0]);
            })
            .addCase(saveSSO.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});

export const initialiseSSOProviderDetails = createAsyncThunk(
    "sso/initialiseSSOProviderDetails",
    (_, thunkAPI) => thunkAPI.dispatch(fetchSSOProviders()),
);

// This is a thunk, they are used to load the state
const fetchSSOProviders = createAsyncThunk(
    "sso/fetchSSOProviders",
    () => Datastore.getType<SSOProvider[]>("api/SSO/SAML"),
    {
        condition: (_, api) => store.getState().db.sso.status === "idle",
    },
);
export const saveSSO = createAsyncThunk(
    "sso/saveSSO",
    async (payload: SSOProvider) => {
        if (payload.id) {
            return Datastore.putType<SSOProvider[]>("api/SSO/SAML", [payload]);
        } else {
            return Datastore.postType<SSOProvider[]>("api/SSO/SAML", [payload]);
        }
    },
    {
        condition: (_, api) => store.getState().db.sso.status === "succeeded",
    },
);

// We have to export the reducer as this is added to the state store
export default ssoSlice.reducer;
